export const UPDATE_SHARE_LIST = 'UPDATE_SHARE_LIST';
export const RESET_SHARE_LIST = 'RESET_SHARE_LIST';

export interface IShareHotelStoreState {
  shareHotelsList: null | object;
}

export interface IShareHotelList {
  data: object
}

export interface IUpdateShareHotelList {
  type: typeof UPDATE_SHARE_LIST;
  actionData: IShareHotelList['data'];
}

export interface IResetShareHotelList {
  type: typeof RESET_SHARE_LIST;
  actionData: null;
}

export type ShareHotelActionTypes = IUpdateShareHotelList | IResetShareHotelList;

